import { useEffect, useRef, useState } from 'react';

export default function CTASection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-28 px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/2a5daebb0456936a98f21967df94baab.jpg"
          alt="SELLCORE Luxury Home Orlando"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: 'rgba(255,255,255,0.88)' }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0.6) 100%)' }} />
      </div>

      {/* Terracotta accent line */}
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: 'linear-gradient(to right, transparent, #DC5014, transparent)' }} />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div
          className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="font-sans text-xs tracking-[0.4em] uppercase font-500 mb-6" style={{ color: '#DC5014' }}>
            Limited Availability
          </p>
          <h2 className="font-playfair font-bold uppercase leading-none mb-6" style={{ fontSize: 'clamp(36px, 6vw, 72px)', color: '#143C3C' }}>
            YOUR DREAM HOME<br />
            <span style={{ color: '#DC5014', fontStyle: 'italic' }}>STARTS HERE.</span>
          </h2>
          <div className="w-16 h-px mx-auto mb-8" style={{ background: '#DC5014' }} />
          <p className="font-sans text-lg leading-relaxed font-300 max-w-2xl mx-auto mb-10" style={{ color: 'rgba(20,60,60,0.65)', fontWeight: 300 }}>
            We accept a limited number of projects each quarter to ensure every client receives our full attention and uncompromising quality.
            Secure your spot before it&apos;s gone.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <button
              onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="font-bold text-lg tracking-widest uppercase px-12 py-5 rounded-sm active:scale-95 transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ background: '#DC5014', color: '#FFFFFF', border: 'none' }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = '#BF4411'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = '#DC5014'; }}
            >
              RESERVE YOUR SLOT NOW
            </button>
          </div>

          {/* Scarcity */}
          <div className="inline-flex items-center gap-3 rounded-sm px-6 py-3" style={{ background: 'rgba(20,60,60,0.06)', border: '1px solid rgba(20,60,60,0.15)' }}>
            <div className="w-2 h-2 flex-shrink-0 rounded-full animate-pulse" style={{ background: '#143C3C' }} />
            <span className="font-sans text-sm font-600 tracking-widest uppercase whitespace-nowrap" style={{ color: '#143C3C' }}>
              Only 3 Premium Project Slots Remaining — Q2 2026
            </span>
          </div>
        </div>
      </div>

      {/* Bottom accent */}
      <div className="absolute bottom-0 left-0 right-0 h-1" style={{ background: 'linear-gradient(to right, transparent, rgba(220,80,20,0.3), transparent)' }} />
    </section>
  );
}
